var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExclamationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 36.6667C10.7952 36.6667 3.3335 29.205 3.3335 20C3.3335 10.795 10.7952 3.33333 20.0002 3.33333C29.2052 3.33333 36.6668 10.795 36.6668 20C36.6668 29.205 29.2052 36.6667 20.0002 36.6667ZM20.0002 33.3333C23.5364 33.3333 26.9278 31.9286 29.4283 29.4281C31.9287 26.9276 33.3335 23.5362 33.3335 20C33.3335 16.4638 31.9287 13.0724 29.4283 10.5719C26.9278 8.07142 23.5364 6.66666 20.0002 6.66666C16.4639 6.66666 13.0726 8.07142 10.5721 10.5719C8.07159 13.0724 6.66683 16.4638 6.66683 20C6.66683 23.5362 8.07159 26.9276 10.5721 29.4281C13.0726 31.9286 16.4639 33.3333 20.0002 33.3333ZM18.3335 26C18.3335 25.4477 18.7812 25 19.3335 25H20.6668C21.2191 25 21.6668 25.4477 21.6668 26V27.3333C21.6668 27.8856 21.2191 28.3333 20.6668 28.3333H19.3335C18.7812 28.3333 18.3335 27.8856 18.3335 27.3333V26ZM18.3335 12.6667C18.3335 12.1144 18.7812 11.6667 19.3335 11.6667H20.6668C21.2191 11.6667 21.6668 12.1144 21.6668 12.6667V20.6667C21.6668 21.2189 21.2191 21.6667 20.6668 21.6667H19.3335C18.7812 21.6667 18.3335 21.2189 18.3335 20.6667V12.6667Z",
    fill: "#B6281E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamationRed);
export default __webpack_public_path__ + "static/media/icon-exclamation-red.d52e3d0addb42915f77c4bd559bdd5a8.svg";
export { ForwardRef as ReactComponent };